import en from './en.json';
import fr from './fr.json';

export const contactsI18n = {
  fr,
  en,
};
